import { useState, useEffect } from "react"
import supabase from "../../utils/subabaseClient"
import { useAuth } from "../../Contexts/AuthContext"
export default function useData() {
  const { user } = useAuth()
  const [expenseGroups, setExpenseGroups] = useState([])

  const fetchExpenseGroups = async () => {
    if (!user) return
    const { data, error } = await supabase
      .from("expense_groups")
      .select("*")
      .order("created_at", { ascending: false })
    if (error) {
      console.error("Error fetching expense groups:", error.message)
    } else {
      const filteredData = data.filter((group) =>
        group.members.includes(user.id)
      )
      console.log("Expense groups fetched successfully!")
      setExpenseGroups(filteredData)
    }
  }

  useEffect(() => {
    fetchExpenseGroups()
  }, [user])

  return {
    expenseGroups,
    fetchExpenseGroups,
  }
}
